import React, {useEffect} from 'react';
import styled from 'styled-components';
import Paper from '../Paper';
import PaperTitle from '../PaperTitle';
import SGSubtitle from '../Typography/SGSubtitle';
import Grid from '@material-ui/core/Grid';
import {useOktaAuth} from '@okta/okta-react';
import Button from '@material-ui/core/Button';
import {userPageView} from '../../redux/actions';
import {useSelector, useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {useUserInfoState} from 'hooks/useUserInfo/UserInfoProvider';

//#region styled-components
const StyledPaper = styled(Paper)`
  &.hidden {
    display: none;
  }
  code {
    width: 100%;
    word-wrap: break-word;
    display: inline-block;
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;

const StyledButton = styled(Button)`
  height: 40px;
  min-width: 190px;
  margin-left: 6px;
  margin-bottom: 6px;
  border-radius: 10px;
  color: ${props => props.theme.altText};
  background-color: ${props => props.theme.tableRow};
  text-decoration: none;
  text-transform: capitalize;
  display: block;
`;
//#endregion styled-components

function UserLog(props) {
  const {isSettings} = props;

  const {
    state: {isAdmin},
  } = useUserInfoState();

  const dispatch = useDispatch();
  const {oktaAuth} = useOktaAuth();

  const userInfo = useSelector(state => state.userInfo);
  const userPageHistory = useSelector(state => state.userInfo.pages);

  let location = useLocation();
  const pathname = location.pathname;

  //#region useEffect
  useEffect(() => {
    if (!isSettings) {
      dispatch(userPageView(pathname));
    }
  }, [isSettings, pathname, dispatch]);
  //#endregion useEffect

  return (
    <>
      {isSettings && (
        <StyledPaper className={isSettings ? '' : 'hidden'}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PaperTitle>Log User Info</PaperTitle>
              <SGSubtitle className={'grey'}>ADMIN</SGSubtitle>
            </Grid>
            <Grid item xs={12}>
              {isAdmin && (
                <StyledButton onClick={() => oktaAuth.handleAuthentication()}>
                  Handle Auth
                </StyledButton>
              )}
            </Grid>
            {isAdmin && (
              <Grid item xs={12}>
                <PaperTitle>User Groups</PaperTitle>
                <code>{userInfo && userInfo?.user?.groups}</code>
              </Grid>
            )}
            {isAdmin && (
              <Grid item xs={12}>
                <PaperTitle>History</PaperTitle>
                {userPageHistory.map((page, index) => (
                  <code key={index}>{page}</code>
                ))}
              </Grid>
            )}
          </Grid>
        </StyledPaper>
      )}
    </>
  );
}

export default UserLog;
